<template>
    <!-- Loading -->
    <div class="vld-parent">
        <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128"/>
    </div>

    <!-- Modal close -->
    <div class="w-full h-screen bg-transparent absolute top-0 left-0 right-0 z-40 cursor-default" v-show="(programmeCommitteModal || detailModal || deleteModal)" @click="programmeCommitteModal = false, detailModal = false, deleteModal = false"></div>

    <!-- Form Modal -->
    <vue-final-modal
    v-model="programmeCommitteModal"
    classes="base-modal"
    :ssr="true"
    :content-class="darkMode ? 'add-modal bg-darkmode-base transition-colors duration-1000' : 'add-modal bg-gray-100 transition-colors duration-1000'"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
    >
    <!-- Modal header -->
    <div class="modal-head">
        <h1 v-if="showEdit">{{ $t('programmeCommitte.detaileditform') }}</h1>
        <h1 v-else>{{ $t('programmeCommitte.detailaddform') }}</h1>

        <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="programmeCommitteModal = false"
        />
    </div>

    <!-- Modal content -->
    <div class="modal-content">
        <programme-committe-form
        :prop-class="programmeCommitteObject"
        :programme-id="programmeId"
        :show-edit="showEdit"
        @close-modal="hideModal"
        @refresh-list="refresh"
        @reset-modal="resetModal"
        />
    </div>
    </vue-final-modal>

    <!-- Detail modal -->
    <vue-final-modal
    v-model="detailModal"
    classes="base-modal"
    :ssr="true"
    content-class="add-modal bg-gray-100 dark:bg-gray-700 transition-colors duration-1000"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false" transition="vfm" overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false" drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
    >
    <!-- Modal header -->
    <div class="modal-head">
        <h1>{{ $t('programmeCommitte.detail') }}</h1>

        <jb-button class="btn-close-modal" :icon="mdiClose" @click="detailModal = false" />
    </div>

    <!-- Modal Content -->
    <div class="modal-content detail-content">
        <programme-committe-detail
            :prop-class="programmeCommitteObject"
            @close-modal="hideModal"
        />
    </div>
    </vue-final-modal>

    <!-- Delete Modal -->
    <vue-final-modal
    v-model="deleteModal"
    classes="base-modal"
    :ssr="true"
    :content-class="darkMode ? 'delete-modal bg-darkmode-base transition-colors duration-1000' : 'delete-modal bg-gray-100 transition-colors duration-1000'"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
    >
    <!-- Modal header -->
    <div class="modal-head">
        <h1>{{ $t('menu.delete') }} {{ $t('menu.data') }}</h1>

        <jb-button class="btn-close-modal" :icon="mdiClose" @click="deleteModal = false" />
    </div>

    <!-- Modal content -->
    <div class="delete-content">
        <div class="warning">{{ $t('menu.warning') }}</div>

        <div class="messsage"><p>{{ $t('confirmDelete.message') }}</p></div>
    </div>

    <!-- Button action -->
    <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
        <jb-buttons class="buttons-action-submit">
        <jb-button :label="$t('finance.button.btnConfirm')" color="info" :icon="mdiTrashCan" @click="confirm" class="form-submit-btn" />
        <jb-button :label="$t('finance.button.btnCancel')" outline @click="cancel" class="btn-reset form-noicon-btn" />
        </jb-buttons>
    </div>
    </vue-final-modal>
    <!-- Main section -->
    <main-section class="overflow-x-hidden">

        <!-- Add button -->
        <jb-button label="Add" color="info" :icon="mdiPlusCircleOutline" small @click="addProgrammeCommitte()" class="ml-4 w-auto px-8   py-2 md:hidden" />

        <!-- Table data -->
        <card-component class="relative mt-2 px-2 md:px-4 bg-white border border-gray-100 dark:bg-gray-900 dark:border-gray-600" :title="$t('programmeCommitte.title')" :icon="mdiCalendar" has-table>
            <jb-button
                label="Add"
                color="info"
                :icon="mdiPlusCircleOutline"
                small
                @click="addProgrammeCommitte()"
                class=" py-1 px-5 shadow-lg mt-1 w-auto absolute right-4 top-1 hidden md:flex">
            </jb-button>
            <ag-grid-vue style="width: 100%; height: 70vh;"
                class="ag-theme-alpine"
                :defaultColDef="defaultColDef"
                :columnDefs="columnDefs"
                :pagination="true"
                :context="context"
                @grid-ready="onGridReady"
                :rowData="rowData.value">
            </ag-grid-vue>
        </card-component>
    </main-section>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import { onMounted, ref, reactive, onUpdated, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { mdiCalendar, mdiCircleEditOutline, mdiTrashCan, mdiPlusCircleOutline, mdiClose } from '@mdi/js'
import MainSection from '@/components/MainSection'
import HeroBar from '@/components/HeroBar'
import TitleBar from '@/components/TitleBar'
import ModalBox from '@/components/ModalBox'
import JbButtons from '@/components/JbButtons'
import Divider from '@/components/Divider'
import JbButton from '@/components/JbButton'
import CardComponent from '@/components/CardComponent'
import { useToast } from 'vue-toastification'
import ProgrammeCommitteForm from '@/views/humanresource/programmeCommitte/ProgrammeCommitteForm'
import ProgrammeCommitteDetail from '@/views/humanresource/programmeCommitte/ProgrammeCommitteDetail'
import Field from '@/components/Field'
import Control from '@/components/Control'
// import { getDepartmentData, getAcademicYearData, getLevelData } from '@/composables/global'
import { AgGridVue } from 'ag-grid-vue3'
import { useI18n } from 'vue-i18n'
import ButtonActionRender from '@/components/ButtonActionRender'
import ButtonActive from '@/components/ButtonActive'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
components: {
    MainSection,
    Loading,
    TitleBar,
    CardComponent,
    HeroBar,
    ProgrammeCommitteDetail,
    ProgrammeCommitteForm,
    ModalBox,
    JbButton,
    JbButtons,
    Divider,
    AgGridVue,
    Control,
    Field,
    ButtonActive,
    ButtonActionRender
},
props: {
    propClass: {
        type: Object,
        default: () => ({ empty: true })
    },
    programmeId: {
        type: String,
        default: ''
    },
},

setup (props, { emit }) {
    // state validation
    const { t } = useI18n()
    const isLoading = ref(false)
    const rowData = reactive([])
    // const { departmentList } = getDepartmentData()
    // const { academicYearList } = getAcademicYearData()
    // const { levelList } = getLevelData()
    const filter = reactive({
        id: '',
        programme_id: '',
        employee_id: '',
        committe_role_id: ''
    })
    const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded)
    const store = useStore()
    const toast = useToast()
    // const titleStack = ref([t('main.master'), t('holidaysDepartment.title')])
    const programmeCommitteModal = ref(false)
    const detailModal = ref(false)
    const deleteModal = ref(false)
    const programmeCommitteObject = ref()
    const programmeId = ref(props.programmeId)
    const showEdit = ref(false)
    const confirm = () => confirmDelete()

    const cancel = () => deleteModal.value = false

        const columnDefs = [
            { headerName: '#', valueGetter: 'node.rowIndex+1' },
            { field: 'employee_name', headerName: t('programmeCommitte.employee'), sortable: true, filter: true, minWidth: 150 },
            { field: 'role_name', headerName: t('programmeCommitte.role'), sortable: true, filter: true, minWidth: 150 },
            { field: 'job_description', headerName: t('programmeCommitte.jobdescription'), sortable: true, filter: true, width: 300 },
            { field: 'id', headerName: t('main.action'), sortable: true, filter: true, minWidth: 165, cellRendererFramework: 'ButtonActionRender' }
        ]

        const defaultColDef = {
            resizable: true
        }

        const refresh = async () => {
            isLoading.value = true
            const url = props.programmeId ? `programme-committe?programme_id=${props.programmeId}` : 'programme-committe'
            await axios
            .get(url)
            .then(response => {
                rowData.value = response.data.data
                // filter.department_id = departmentList.value[0].id
                isLoading.value = false
            }).catch(error => {
                toast.error(error.response.data, { timeout: 5000 })
                console.log(error)
                isLoading.value = false
            })
        }

    // mounted
    onMounted(() => {
    // get API from Laravel Backend
    // refresh()
    })


    watch(() => props.programmeId, (newVal, oldVal) => {
        refresh()
    })

        const hideModal = () => {
            programmeCommitteModal.value = false
            refresh()
        }

        const showModal = () => {
            programmeCommitteModal.value = !programmeCommitteModal.value
        }

        const resetModal = () => {
            // filter.department_id = ''
            // filter.programme_id = ''
            filter.employee_id = ''
            filter.committe_role_id = ''
        }

        const addProgrammeCommitte = () => {
            // alert('tes')
            showModal()
            resetModal()
            showEdit.value = false
            programmeCommitteObject.value = filter
            programmeId.value = props.programmeId
        }

        const detailData = (event, kelas) => {
            detailModal.value = true
            programmeCommitteObject.value = kelas
        }

        const editData = (event, kelas) => {
            showModal()
            programmeCommitteObject.value = kelas
            programmeId.value = props.programmeId
            console.log('programmeCommitteObject.value', programmeCommitteObject.value)
            showEdit.value = true
        }

        const deleteModalShow = (value) => {
            deleteModal.value = true
            console.log('deleteModal.value', value)
            deleteModal.id=value
        }

        const confirmDelete = () => {
            axios
            .delete(`programme-committe/${deleteModal.id}`)
            .then(response => {
                if (response.data.success) {
                    refresh()

                    toast.success(response.data.message, { timeout: 5000 })
                } else {
                    toast.error(response.data.message, { timeout: 5000 })
                }
                deleteModal.value = false
            }).catch(error => {
                    toast.error(error.response.data.message, { timeout: 5000 })
                    console.log(error)
                    deleteModal.value = false
            })
        }

    // return
    return {
    // titleStack,
    isLoading,
    programmeCommitteObject,
    programmeId,
    showEdit,
    programmeCommitteModal,
    addProgrammeCommitte,
    hideModal,
    showModal,
    detailModal,
    detailData,
    editData,
    mdiCalendar,
    mdiClose,
    mdiCircleEditOutline,
    mdiTrashCan,
    mdiPlusCircleOutline,
    toast,
    refresh,
    rowData,
    filter,
    // departmentList,
    // academicYearList,
    // levelList,
    columnDefs,
    defaultColDef,
    t,
    gridApi: null,
    gridColumnApi: null,
    ButtonActionRender,
    deleteModal,
    deleteModalShow,
    confirm,
    cancel,
    confirmDelete,
    resetModal,
    isAsideMobileExpanded
    }
},
    beforeMount() {
    this.context = {
        componentParent: this
    }
    },
    methods: {
        onGridReady (params) {
            this.gridApi = params.api
            this.gridColumnApi = params.columnApi
            const allColumnIds = []
            this.gridColumnApi.getAllColumns().forEach((column) => {
                allColumnIds.push(column.colId)
            });
            this.gridColumnApi.autoSizeColumns(allColumnIds, false)
        }
    }
}
</script>
